import script from './Tree.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"tree"},_vm._l((_vm.items),function(item){return _c('TreeItem',{key:item.id,attrs:{"item":item,"activeIds":_vm.activeIds,"depth":1,"isActive":_vm.activeIds[0] === item.id,"isCurrentSelection":_vm.activeIds[0] === item.id && _vm.activeIds.length === 1,"showItemCount":_vm.showItemCount,"showToplevelFlag":_vm.showToplevelFlag,"showSubitemFlag":_vm.showSubitemFlag},on:{"click":_vm.onClick}})}),1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-598bb2a7_0", { source: ".tree[data-v-598bb2a7]{display:block;padding:4px 0;list-style:none;overflow-y:auto;overscroll-behavior:contain}@media only screen and (max-width:1279px){.tree[data-v-598bb2a7]{max-height:unset!important;overflow:visible}}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-598bb2a7";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
